import { createFileRoute } from "@tanstack/react-router";
import { PlaceholderShell } from "@/components/admin/PlaceholderShell";

export const Route = createFileRoute("/admin/leads")({
  head: () => ({
    meta: [
      { title: "Leads · Admin" },
      { name: "robots", content: "noindex, nofollow" },
    ],
  }),
  component: AdminLeads,
});

function AdminLeads() {
  return (
    <div>
      <PlaceholderShell
        title="Leads"
        description="Submitted applications and partial leads across every loan product."
        checklist={[
        "Full and partial lead list",
        "Filter by product, state, and source",
        "Push status to CRM and Zapier",
        "Open the borrower's full application",
        ]}
      />
    </div>
  );
}
